import { useEffect, useState } from 'react';
import Framework from './Framework/Framework';
import { Back } from '../../../../../../../components/back/Back';
import './CodeSetting.css'
import SpringbootSettings from './Framework/springbootSettings/SpringbootSettings';

const CodeSettings = ({ serviceName, setCode, code, next, back, direction }) => {

    const [languageVar, setLanguageVar] = useState(code.language !== "" ? code.language : "Python")
    const [frameworkSetting, setFrameworkSetting] = useState(Object.keys(code.framework).length !== 0 ? code.framework : {
        framework_type: ""
    })
    const getAdditionalOptions = () => {
        return languages
                .find(l => l.name === languageVar)
                ?.frameworkOptions.find(f => f.value === frameworkSetting.framework_type)
                ?.addionalConfiguration;

    }
    const languages = [
        {
            name: "Python",
            frameworkOptions: [
                {
                    name: "Flask",
                    value: "Flask",
                    addionalConfiguration: null
                },
                {
                    name: "none",
                    value: "",
                    addionalConfiguration: null
                },
            ]
        },
        {
            name: "Java",
            frameworkOptions: [
                {
                    name: "Spring Boot",
                    value: "Springboot",
                    addionalConfiguration: <SpringbootSettings serviceName={serviceName} intialData={frameworkSetting} back={(data)=>{setCode(languageVar, {...frameworkSetting, ...data});setCurrentPage("main")}} next={(data)=>{setCode(languageVar, {...frameworkSetting, ...data});next()}}/>
                },
                {
                    name: "none",
                    value: "",
                    addionalConfiguration: null
                },
            ]
        },
        {
            name: "JavaScript",
            frameworkOptions: [
                {
                    name: "React",
                    value: "React",
                    addionalConfiguration: null
                }
            ]
        }
    ]
    const [currentPage, setCurrentPage] = useState((getAdditionalOptions()) && direction === "back" ? "additional-settings" : "main")


    return (
        <div className='code-setting'>
            { currentPage === "main" && 
                <div className='main-page'>
                    <Back back={()=>{setCode(languageVar, frameworkSetting);back()}}/>
                    <h1>Code Settings</h1>
                    <form>
                        <div className='info-block'>
                            <label >Language:</label>
                            <select onChange={(e) =>
                                    setLanguageVar(e.target.value)
                                }>
                                    {languages.map(language=>{
                                        return <option selected={languageVar === language.name} value={language.name}>{language.name}</option>})}
                            </select>
                        </div>
                        <Framework language={languageVar} frameworkSetting={frameworkSetting} setFramework={setFrameworkSetting} languages={languages}/>
                        <button className='next-button' onClick={()=>{
                            setCode(languageVar, frameworkSetting);
                            if (getAdditionalOptions()){
                                setCurrentPage("additional-settings")
                            }else {
                                next()
                            }}}>next</button>
                    </form>
                </div>
            }
            {currentPage === "additional-settings" &&
                getAdditionalOptions()}
        </div>
    );
};

export default CodeSettings;